// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (kkm) {
    return function (org) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const contextRoute = function (route) {
        return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
      };
      const match$2 = React.useState(function () {
            return "0xFFFF00000007";
          });
      const setReason = match$2[1];
      const reason = match$2[0];
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: "Снятие кассы с учета"
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-6 h-6",
                                              src: StaticAsset.src("/static/icons/close.svg")
                                            }),
                                        onClick: (function (param) {
                                            Curry._1(onClose, undefined);
                                          })
                                      })
                                ],
                                className: "px-6 py-4 flex justify-between"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "text-asphalt",
                                        children: "Причина снятия кассы с учета:"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF00000007",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF00000007";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: "Прекращение осуществления деятельности, связанной с денежными расчетами"
                                            })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF00000009",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF00000009";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: "Техническая неисправность ККМ"
                                            })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF0000000A",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF0000000A";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: "Исключение ККМ из государственного реестра"
                                            })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF0000000D",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF0000000D";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: "Замена на новую модель"
                                            })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF0000000E",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF0000000E";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: [
                                                "Кража или утеря",
                                                JsxRuntime.jsx("br", {}),
                                                JsxRuntime.jsx("span", {
                                                      children: "при наличии копии заявления о краже",
                                                      className: "text-asphalt"
                                                    })
                                              ]
                                            })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                        className: "mt-4",
                                        checked: reason === "0xFFFF0000000B",
                                        onChange: (function (param) {
                                            Curry._1(setReason, (function (param) {
                                                    return "0xFFFF0000000B";
                                                  }));
                                          }),
                                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "ml-2",
                                              children: "Другой случай, не противоречащий налоговому законодательству Республики Казахстан"
                                            })
                                      })
                                ],
                                className: "px-6 py-4"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                      title: "Подписать и отправить в КГД",
                                      onClick: (function (param) {
                                          const form = {
                                            unregister_reason_code: reason
                                          };
                                          const __x = Buhta_cabinet__Kassa.KkmManagerService.unregister(tenant, kkm.id, form);
                                          $$Promise.get(__x, (function (result) {
                                                  if (result.TAG !== /* Ok */0) {
                                                    return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                                  }
                                                  Curry._1(onClose, undefined);
                                                  Buhta_cabinet__Route.navigateTo(contextRoute({
                                                            TAG: /* Kassa */2,
                                                            _0: /* Kkms */{
                                                              _0: /* List */1
                                                            }
                                                          }));
                                                  Curry._1(dispatchToasts, {
                                                        TAG: /* Add */0,
                                                        _0: {
                                                          id: Buhta_core__Toast.generateId(undefined),
                                                          text: "Форма на снятие с учета ККМ принята",
                                                          kind: "success",
                                                          onClick: (function (param) {
                                                              
                                                            })
                                                        }
                                                      });
                                                }));
                                        }),
                                      className: "py-3 w-full"
                                    }),
                                className: "px-6 py-4"
                              })
                        ],
                        className: "w-106 bg-white rounded shadow-payroll"
                      }),
                  className: "absolute inset-0 bg-black/40 flex justify-center items-center"
                });
    };
  };
}

function KkmUnregisterModal(Props) {
  return Curry._1(make(Props.onClose)(Props.kkm), Props.org);
}

const make$1 = KkmUnregisterModal;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
